import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import BlogModal from "../../models/blog.modal";
import { helper } from "lib/helper";

const Blog = () => {
  const [item, setItem] = useState();
  const [modal5, setModal5] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [modal, setModal] = useState(false);
  const [data, setData] = useState();
  const [expandedItems, setExpandedItems] = useState({});
  const [expandedItems1, setExpandedItems1] = useState({});

  const toggleExpand = (index) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  const toggleExpand1 = (index) => {
    setExpandedItems1((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  const toggleModal = () => {
    setModal(!modal);
  };
  const toggleModal1 = () => {
    setModal1(!modal1);
  };
  const Bloglist = () => {
    // Dummy data for blogs
    const dummyBlogData = {
      data: [
        {
          id: "1",
          title: "How to Excel in Mathematics: Tips and Tricks for Students",
          category: "Education",
          short_desc: "Mathematics can be challenging, but with the right approach and techniques, any student can master it. This guide provides practical tips for improving math skills.",
          long_desc: "Mathematics is often considered one of the most challenging subjects by students across all grade levels. However, with proper understanding, consistent practice, and the right strategies, anyone can excel in mathematics. This comprehensive guide covers fundamental concepts, problem-solving techniques, and study methods that have proven effective for thousands of students. We'll explore how to build a strong foundation, tackle complex problems step by step, and develop mathematical thinking that will serve you throughout your academic journey and beyond.",
          image: {
            link: "https://via.placeholder.com/400x250/0066FF/FFFFFF?text=Math+Tips"
          }
        },
        {
          id: "2",
          title: "The Importance of Science Education in Modern World",
          category: "Science",
          short_desc: "Science education plays a crucial role in developing critical thinking and problem-solving skills. Learn why science literacy is essential for every student.",
          long_desc: "In today's rapidly evolving world, science education has become more important than ever before. From understanding climate change to making informed decisions about health and technology, scientific literacy is essential for active citizenship. This article explores the multifaceted benefits of science education, including its role in developing analytical thinking, fostering innovation, and preparing students for careers in STEM fields. We'll discuss how quality science education can inspire curiosity, encourage experimentation, and build the foundation for lifelong learning. Whether you're a student, parent, or educator, understanding the value of science education is crucial for navigating our increasingly complex world.",
          image: {
            link: "https://via.placeholder.com/400x250/FF6600/FFFFFF?text=Science+Education"
          }
        },
        {
          id: "3",
          title: "Effective Study Techniques for Competitive Exams",
          category: "Exam Preparation",
          short_desc: "Preparing for competitive exams requires strategic planning and effective study methods. Discover proven techniques to maximize your preparation time.",
          long_desc: "Competitive exams like JEE, NEET, and various entrance tests require more than just hard work – they demand smart preparation strategies. This comprehensive guide outlines time-tested study techniques that have helped thousands of students achieve their goals. We'll cover topics such as creating effective study schedules, using active recall methods, practicing with mock tests, and managing exam stress. Learn how to identify your strengths and weaknesses, allocate time efficiently across subjects, and maintain motivation throughout your preparation journey. These strategies are backed by educational research and have been refined through years of successful implementation.",
          image: {
            link: "https://via.placeholder.com/400x250/00CC66/FFFFFF?text=Exam+Prep"
          }
        },
        {
          id: "4",
          title: "Parent's Guide to Supporting Your Child's Education",
          category: "Parenting",
          short_desc: "Parents play a vital role in their child's educational journey. Learn how to provide effective support without overwhelming your child.",
          long_desc: "As a parent, you want to support your child's education in the best way possible, but it can be challenging to know how to help effectively. This guide provides practical advice for parents on how to create a supportive learning environment at home, communicate with teachers, and encourage academic growth without adding unnecessary pressure. We'll explore topics such as establishing good study habits, dealing with homework challenges, celebrating achievements, and handling academic setbacks. Learn how to be your child's advocate while fostering independence and self-motivation. This comprehensive resource draws from educational psychology and real-world experiences of successful families.",
          image: {
            link: "https://via.placeholder.com/400x250/9933CC/FFFFFF?text=Parent+Guide"
          }
        },
        {
          id: "5",
          title: "The Future of Online Learning: Trends and Opportunities",
          category: "Technology",
          short_desc: "Online learning has revolutionized education. Explore the latest trends, benefits, and future possibilities of digital education platforms.",
          long_desc: "The landscape of education has been dramatically transformed by digital technology, with online learning becoming an integral part of modern education. This article examines the current state of online learning, emerging trends, and future opportunities in digital education. We'll discuss the advantages of personalized learning, the role of artificial intelligence in education, virtual reality applications, and the growing importance of digital literacy. Learn about innovative teaching methods, interactive learning platforms, and how technology is making quality education more accessible to students worldwide. Whether you're an educator, student, or parent, understanding these trends will help you navigate the evolving educational landscape.",
          image: {
            link: "https://via.placeholder.com/400x250/FF3366/FFFFFF?text=Online+Learning"
          }
        },
        {
          id: "6",
          title: "Building Strong Foundation in English Language Skills",
          category: "Language",
          short_desc: "Strong English language skills are essential for academic and professional success. Discover methods to improve reading, writing, and communication abilities.",
          long_desc: "English language proficiency is crucial for success in today's globalized world. Whether you're preparing for academic exams, professional opportunities, or simply want to communicate more effectively, building strong English skills is essential. This comprehensive guide covers all aspects of English language learning, including grammar fundamentals, vocabulary building, reading comprehension strategies, and effective writing techniques. We'll explore methods for improving pronunciation, developing fluency in speaking, and understanding cultural nuances in communication. Learn about resources, practice exercises, and proven techniques that can help you master English at any level. This guide is designed for students, professionals, and anyone looking to enhance their English language abilities.",
          image: {
            link: "https://via.placeholder.com/400x250/33CCFF/FFFFFF?text=English+Skills"
          }
        }
      ]
    };
    
    setTimeout(() => {
      setData(dummyBlogData);
    }, 1000);
  };
  useEffect(() => {
    Bloglist();
  }, []);

  const AddBlog = (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    
    // Simulate adding new blog
    const newBlog = {
      id: (data?.data?.length + 1).toString(),
      title: form.get("title"),
      category: form.get("category"),
      short_desc: form.get("short_desc"),
      long_desc: form.get("long_desc"),
      image: {
        link: "https://via.placeholder.com/400x250/666666/FFFFFF?text=New+Blog"
      }
    };
    
    setTimeout(() => {
      setData(prevData => ({
        ...prevData,
        data: [...(prevData?.data || []), newBlog]
      }));
      toggleModal();
      helper.sweetalert.toast("Blog added successfully", "success");
    }, 500);
  };
  console.log("item detail ",item)
  const EditBlog = (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    
    // Simulate editing blog
    setTimeout(() => {
      setData(prevData => ({
        ...prevData,
        data: prevData.data.map(blog => 
          blog.id === item?.id 
            ? {
                ...blog,
                title: form.get("title") || blog.title,
                category: form.get("category") || blog.category,
                short_desc: form.get("short_desc") || blog.short_desc,
                long_desc: form.get("long_desc") || blog.long_desc
              }
            : blog
        )
      }));
      toggleModal1();
      helper.sweetalert.toast("Blog updated successfully", "success");
    }, 500);
  };
  const DeleteBlog = (id) => {
    // Simulate deleting blog
    setTimeout(() => {
      setData(prevData => ({
        ...prevData,
        data: prevData.data.filter(blog => blog.id !== id)
      }));
      helper.sweetalert.toast("Blog deleted successfully", "success");
    }, 500);
  };
  const formatTextWithLineBreaks = (text, wordsPerLine = 3) => {
    const words = text.split(" ");
    return words.reduce((acc, word, index) => {
      if ((index + 1) % wordsPerLine === 0) {
        return acc + word + "<br />"; // Add a break after every 10th word
      }
      return acc + word + " ";
    }, "");
  };
  return (
    <Container className="px-4 py-7">
      <Card className="shadow">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Blogs</h3>

                <div className="d-flex flex-row">
                  <Button
                    size="sm"
                    onClick={toggleModal}
                    style={{ backgroundColor: "#080278", color: "white" }}
                  >
                    +Add
                  </Button>
                </div>
              </CardHeader>
            </Card>
          </div>
        </Row>
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>
              <th>S.NO</th>
              <th>Image</th>

              <th>Title</th>
              <th>Category</th>

              <th>Short_desc</th>
              <th>long_desc</th>

              <th>Action</th>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "white" }}>
            {data?.data?.map((item, index) => {
              const isExpanded = expandedItems[index] || false;
              const previewText = item?.long_desc.slice(0, 50); // Preview of the first 50 characters
              const fullText = item?.long_desc;

              const isExpanded1 = expandedItems1[index] || false;
              const previewText1 = item?.short_desc.slice(0, 50); // Preview of the first 50 characters
              const fullText1 = item?.short_desc;

              const formattedShortDesc = formatTextWithLineBreaks(
                item?.short_desc
              );
              const formattedLongDesc = formatTextWithLineBreaks(
                item?.long_desc
              );
              const formattedTitle = formatTextWithLineBreaks(item?.title); // Format title with line breaks

              return (
                <tr key={item?.id}>
                  <th>{index + 1}</th>
                  <th>
                    <img
                      src={item?.image?.link}
                      alt="image"
                      height="70px"
                      width="120px"
                      style={{ border: "1px solid black" }}
                    />
                  </th>

                  {/* Title with line breaks */}
                  <th>
                    <p
                      style={{ cursor: "pointer" }}
                      dangerouslySetInnerHTML={{
                        __html: formattedTitle,
                      }}
                    />
                  </th>

                  <th>
                    <p>{item?.category}</p>
                  </th>

                  {/* Short description with line breaks */}
                  <th>
                    <p
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleExpand1(index)}
                      dangerouslySetInnerHTML={{
                        __html: isExpanded1 ? formattedShortDesc : previewText1,
                      }}
                    />
                    {fullText1.length > 50 && (
                      <span
                        style={{
                          color: "blue",
                          textDecoration: "underline",
                          fontSize: "12px",
                        }}
                        onClick={() => toggleExpand1(index)}
                      >
                        {isExpanded1 ? " Read Less" : "... Read More"}
                      </span>
                    )}
                  </th>

                  {/* Long description with line breaks */}
                  <th>
                    <p
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleExpand(index)}
                      dangerouslySetInnerHTML={{
                        __html: isExpanded ? formattedLongDesc : previewText,
                      }}
                    />
                    {fullText.length > 50 && (
                      <span
                        style={{
                          color: "blue",
                          textDecoration: "underline",
                          fontSize: "12px",
                        }}
                        onClick={() => toggleExpand(index)}
                      >
                        {isExpanded ? " Read Less" : "... Read More"}
                      </span>
                    )}
                  </th>

                  <th>
                    {/* Edit and Delete buttons */}
                    <Link
                      style={{
                        fontSize: "15px",
                        color: "blue",
                        alignItems: "center",
                        display: "inline-block",
                        borderRadius: "30%",
                      }}
                      id={`eyeTooltip-${index}`}
                      onClick={() => {
                        toggleModal1();
                        setItem(item);
                      }}
                    >
                      <i className="fa-solid fa-pen-to-square"></i>
                    </Link>

                    <UncontrolledTooltip
                      placement="top"
                      target={`eyeTooltip-${index}`}
                    >
                      Edit
                    </UncontrolledTooltip>

                    <p
                      style={{
                        margin: "0 8px",
                        fontSize: "15px",
                        color: "red",
                        cursor: "pointer",
                        display: "inline-block",
                        borderRadius: "20%",
                      }}
                      onClick={() => {
                        DeleteBlog(item?.id);
                       
                      }}
                      id={`userTooltip-${index}`}
                    >
                      <i className="fas fa-trash"></i>
                    </p>
                    <UncontrolledTooltip
                      placement="top"
                      target={`userTooltip-${index}`}
                    >
                      Delete
                    </UncontrolledTooltip>
                  </th>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {/*add banner module */}
        <Modal isOpen={modal} toggle={toggleModal} size="lg">
          <ModalHeader toggle={toggleModal}>
            <h4> Add Blog </h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={AddBlog}>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label> Select Image</Label>
                    <Input
                      name="image"
                      type="file"
                      placeholder="Enter Title"
                      style={{
                        border: "1px solid #cad1d7",
                        borderRadius: "0.375rem",
                        padding: "4px",
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Title</Label>
                    <Input type="text" name="title" placeholder="Enter Title" />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Category</Label>
                    <Input
                      name="category"
                      type="text"
                      placeholder="Enter Vedio Type"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                {/* <Col md={6}>
               <FormGroup>
                 z<Label>VideoName
                 </Label>
                 <Input type="text" placeholder="Enter videoname" />
               </FormGroup>
             </Col>*/}
                <Col md={6}>
                  <FormGroup>
                    <Label>Short desc</Label>
                    <Input
                      name="short_desc"
                      type="textarea"
                      placeholder="Enter Description"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Long desc</Label>
                    <Input
                      name="long_desc"
                      type="textarea"
                      placeholder="Enter Description"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal}>
                  Cancel
                </Button>
                {/* 
                     {addsLoadig ? (
                       <Loader color={"blue"} />
                     ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                  }}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
        {/*end*/}
        {/*Edit banner module */}
        <Modal isOpen={modal1} toggle={toggleModal1} size="lg">
          <ModalHeader toggle={toggleModal1}>
            <h4> Edit Blogs </h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={EditBlog}>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label> Select Image</Label>
                    <Input
                      name="image"
                      type="file"
                      placeholder="Enter Title"
                      style={{
                        border: "1px solid #cad1d7",
                        borderRadius: "0.375rem",
                        padding: "4px",
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Title</Label>
                    <Input type="text" name="title" placeholder="Enter Title" defaultValue={item?.title}/>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Category</Label>
                    <Input
                    defaultValue={item?.category
                    }
                      name="category"
                      placeholder="Enter Vedio Type"
                    ></Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                {/* <Col md={6}>
               <FormGroup>
                 z<Label>VideoName
                 </Label>
                 <Input type="text" placeholder="Enter videoname" />
               </FormGroup>
             </Col>*/}
                <Col md={6}>
                  <FormGroup>
                    <Label>Short desc</Label>
                    <Input
                      name="short_desc"
                      type="textarea"
                      defaultValue={item?.short_desc
                      }
                      placeholder="Enter Description"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Sequence</Label>
                    <Input
                      name="long_desc"
                      type="textarea"
                      defaultValue={item?.long_desc}
                      placeholder="Enter Description"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal1}>
                  Cancel
                </Button>
                {/* 
                     {addsLoadig ? (
                       <Loader color={"blue"} />
                     ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                  }}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
        {/*end*/}
        {/*popup Banner*/}
        <Modal isOpen={modal5} toggle="{toggleModal5}" size="lg">
          <ModalHeader toggle="{toggleModal5}">
            <h4>Banner</h4>
          </ModalHeader>
          <ModalBody>
            <img
              src="{image}"
              width="750px"
              height="460px"
              style={{ border: "2px solid gray" }}
            />
          </ModalBody>
        </Modal>
      </Card>
    </Container>
  );
};

export default Blog;
